import React from 'react';
import {Trans} from 'react-i18next';
import Section from '../../layout/Section';
import LeftTitleWithField from '../../layout/LeftTitleWithField';
import {Field} from 'formik';
import CustomSwitch from '../../../../../components/layout/CustomSwitch';
import _get from 'lodash/get';

export default function GetSkinResultGeneralSetting({formikProps}) {
  return (
    <Section
      title={
        <Trans i18nKey="p.s.uiconfiguration.getskinresult.report.access.options">
          Report Access Options
        </Trans>
      }
    >
       <LeftTitleWithField
        title={
          <Trans i18nKey="p.s.uiconfiguration.getskinresult.skin.qrcode">
            QR Code
          </Trans>
        }
      >
        <Field
          name="getPhotoPage.accessOptions.showQRCode"
          value={_get(formikProps.values, 'getPhotoPage.accessOptions.showQRCode')}
          component={CustomSwitch}
        />
      </LeftTitleWithField>
      <LeftTitleWithField
        title={
          <Trans i18nKey="p.s.uiconfiguration.getskinresult.email">
            Email
          </Trans>
        }
      >
        <Field
          name="getPhotoPage.accessOptions.showEmail"
          value={_get(formikProps.values, 'getPhotoPage.accessOptions.showEmail')}
          component={CustomSwitch}
        />
      </LeftTitleWithField>
      <LeftTitleWithField
        title={
          <Trans i18nKey="p.s.uiconfiguration.getskinresult.print">
            Print
          </Trans>
        }
      >
        <Field
          name="getPhotoPage.accessOptions.showPrint"
          value={_get(formikProps.values, 'getPhotoPage.accessOptions.showPrint')}
          component={CustomSwitch}
        />
      </LeftTitleWithField>
    </Section>
  );
}
